import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card, index) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: index,
              cols: "12",
              sm: "6",
              md: "6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  class: _normalizeClass(['content-card', 'h-100', { unavailable: !card.available, 'interactive-card': card.available }]),
                  elevation: "0",
                  onClick: ($event: any) => (card.available && _ctx.$router.push(card.path))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, { class: "text-center py-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, { class: "text-h6 mb-2" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(card.title), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_card_subtitle, { class: "text-subtitle-1 text-grey" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(card.description), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}